import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommentFormComponent } from '../comment-form/comment-form.component';
import { loanMeta } from '../models/loanMeta';
import {
	Component,
	ElementRef,
	inject,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	ChangeDetectorRef,
	Injector,
	Input
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UserOptions } from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import {
	FormControl,
	Validators,
} from '@angular/forms';
import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import { environment } from '@lmc-env/environment';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@lmc-app/shared/interface/user.interface';
import { from, of, shareReplay, Subject, takeUntil, tap } from 'rxjs';
import { LoanMetaService } from '@lmc-app/core/services/loan-meta.service';
import { PageEvent } from '@angular/material/paginator';
import { SaveAlertService } from '@lmc-app/shared/components/save-alert/save-alert.service';
import { SharedLoanMetaModalComponent } from './shared-loan-meta-modal/shared-loan-meta-modal.component';
import { ApplicationService } from '@lmc-app/core/services/application.service';
import { MatSnackBar } from '@angular/material/snack-bar';

interface jsPDFWIthPlugin extends jsPDF {
	autoTable: (options: UserOptions) => jsPDF;
}
interface Comment_Type {
	value: string;
	viewValue: string;
}
interface Disposition {
	id: string;
	name: string;
}
@Component({
	selector: 'app-loan-meta',
	templateUrl: './loan-meta.component.html',
	styleUrls: ['./loan-meta.component.scss'],
	animations: [
		trigger('sideNavMenuAnimationState', [
			state(
				'topX',
				style({
					transform: 'rotate(45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state(
				'hide',
				style({
					opacity: 0,
				})
			),
			state(
				'bottomX',
				style({
					transform: 'rotate(-45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state('line', style({})),
			state(
				'right',
				style({
					marginTop: '2px',
					marginLeft: '2px',
				})
			),
			state(
				'left',
				style({
					transform: 'rotate(-180deg)',
					transformOrigin: 'center',
					marginBottom: '2px',
					marginRight: '2px',
				})
			),
			transition(':enter', []),
			transition('* => *', [animate('0.2s')]),
		]),
	],
	encapsulation: ViewEncapsulation.Emulated,
})
export class LoanMetaComponent implements OnInit, OnDestroy {
	@Input() transunionAppID: any; 
	private readonly _onDestroy = new Subject<void>();
	@ViewChild('content') content: ElementRef;

	noteCols: string[] = ['created', 'note'];  
	// noteDataSource: MatTableDataSource<string[]>;

	// @ViewChild(MatPaginator) paginator!: MatPaginator;
	isSideNavMenuOpen = true;
	notesOpen = true;
	//collections queue variables
	isQueue = false;
	queuedLoans: any;
	loanIndex: any;

	amo_schedule;
	payoff_flag = false;
	release_flag = false;
	userID;
	test_date = new Date();
	mydate;
	comment: any;
	openAmoFlag = false;
	comment_types: Comment_Type[] = [
		{ value: 'Regular', viewValue: 'Regular' },
		{ value: 'Email Notes', viewValue: 'Email Notes' },
	];

	unbilledInterest: any;

	dispositions: Disposition[] = [
		{ id: 'Internal Email', name: 'Internal Email' },
		{ id: 'RIGHT PARTY CONTACT', name: 'RIGHT PARTY CONTACT' },
		{ id: 'WRONG NUMBER', name: 'WRONG NUMBER' },
		{ id: 'THIRD PARTY CONTACT', name: 'THIRD PARTY CONTACT' },
		{ id: 'BANKO/CCS', name: 'BANKO/CCS' },
		{ id: 'LEFT MESSAGE WITH 3RD PARTY', name: 'LEFT MESSAGE WITH 3RD PARTY' },
		{ id: 'LEFT VOICEMAIL WITH RPC', name: 'LEFT VOICEMAIL WITH RPC' },
		{ id: 'HUNG UP/ REFUSAL TO PAY', name: 'HUNG UP/ REFUSAL TO PAY' },
		{ id: 'MANAGER REVIEW', name: 'MANAGER REVIEW' },
		{ id: 'HOLD', name: 'HOLD' },
		{ id: 'HOLD – COMPLAINT UNDER REVIEW', name: 'HOLD – COMPLAINT UNDER REVIEW' },
		{ id: 'NO ANSWER', name: 'NO ANSWER' },
		{ id: 'NO SERVICE', name: 'NO SERVICE' },
		{ id: 'ARRANGMENT MADE', name: 'ARRANGMENT MADE' },
		{ id: 'SKIP', name: 'SKIP' },
		{ id: 'Tel poe lft msg on v/m', name: 'Tel poe lft msg on v/m' },
		{ id: 'Tel poe lft msg', name: 'Tel poe lft msg' },
		{ id: 'Tel poe n/a', name: 'Tel poe n/a' },
		{ id: 'Tel cell lft msg on v/m', name: 'Tel cell lft msg on v/m' },
		{ id: 'Tel cel n/a', name: 'Tel cel n/a' },
		{ id: 'Tel res mail box full', name: 'Tel res mail box full' },
	];
	payment_flag = true;
	meta = new loanMeta();
	// image_base64 = new Images()
	staticAlertClosed = false;
	successMessage = '';
	panelOpenState = true;
	selectedType = 'Regular';
	selectedType_d = 'NO ANSWER';
	collection_info: any;
	client_info: any;
	PD: any;
	manual_payment: any;
	Def_payment: any;
	Comments_table: any;
	// manual_flag: boolean = false;
	amount: number;
	date: any;
	payoff: any;
	payoffRequestedDate: any;
	payoffDownloadData: any;
	payoffRequestedInfo: any;
	showDownloadPayoff: boolean;
	rowDataClicked_Man = [];
	rowDataClicked_Com = [];
	FollowupDate_Formatted: any;
	NLSStatuses: any;
	selectedStatus: any;
	allStatuses: any;

	//Def
	defaultColDef_Def: any;
	public columnDefs_Def = [];
	public rowData_Def;
	public gridApi_Def;
	public gridColumnApi_Def;
	public gridOptions_Def;
	getRowStyle_Def;
	clickEventSubscription;
	//Payment History Summary
	paymentHistorySummary;
	paymentDueSummary;
	paymentDueSummaryFlag = false;
	paymentHistorySummaryFlag = false;
	total_obligation_entire_term = 0;

	// Right child
	moreInfo = false;
	p = 1;
	count = 8;
	spinner = false;

	// Meta Data to assign loan details
	dataFromMeta: any;

	// Balance Total
	totalBalance = 0;


	selectedEmail = '';
	isEmail = false;
	officeEmails: any;
	serverURL: string = environment.iframeURL;

	emailFormControl = new FormControl('', [Validators.required, Validators.email]);
	sentEmailAddress = '';

	userName: any;
	zohoUserID: any;
	empID: any;
	isMatured: boolean = false;

	isQueued:boolean=false;
	// // loanMetaSubscription: Subscription ;
	loanMetaData:any;
	payoff_info:any;
	loanMeta$ = this.loanMetaService.data$;
	emergencyContactNo:any;
	legalStatusUpdateAccess:any;
	externalRole:boolean=false;	
	coAppEmergencySubForm: boolean = false;
	private readonly snackBar = inject(MatSnackBar);
	constructor(
		public datepipe: DatePipe,
		private apiService: LegacyApiService,
		private dialog: MatDialog,
		private router: Router,
		private store: Store<State>,
		private cdr : ChangeDetectorRef,
		private loanMetaService: LoanMetaService,
		private saveAlertService: SaveAlertService,
		private injector: Injector,
		private readonly applicationService: ApplicationService,
	) {
	}
	async ngOnInit() {
		this.toggleSideNav();

		// Subscribe to user from NgRx store
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.userID = user.email;
					this.userName = user.full_name;
					this.zohoUserID = user.zoho_owner_id;
					this.empID = user.employeeID;
					this.externalRole = user.roleID === 13
				}
			});
		this.loanMeta$ = this.loanMetaService.data$.pipe(
  			tap(res => { 
				if (res && !res.notFound) {
					console.log(res,"Data")
					this.isQueued = this.loanMetaService.isIndividualSearch();
					this.collection_info = res?.main;
					this.transunionAppID = this.collection_info?.cifnumber;
					this.loanMetaData = res?.loanDetailData;
					this.Comments_table = res?.noteData;
					this.payoff_info = res?.payOffData;
					this.Def_payment = res?.deferredData;
					this.collection_info.EmergencyContact = res?.emergencyContact?.emergency_contact;	// Separate api with the emergency contact
					this.collection_info.CoAppEmergencyContact = res?.coAppEmergencyContact?.coapp_emergency_contact;	// Separate api with the coApp emergency contact future subforms
					this.coAppEmergencySubForm = !!this.collection_info.CoAppEmergencyContact;	// Hide if no subform
					this.legalStatusUpdateAccess = res?.buttonPermissionData?.[0]?.status_update;
					this.populateMetaDetails();					
					this.customAgGridColumns();
					this.resetNoteForm();
				} else {
					this.collection_info = null; 
					console.log("No Data.")
				}
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		)
	}

	customAgGridColumns(){
		//Deferred Payments
		this.columnDefs_Def = [
			{
				headerName: 'Payment #',
				field: 'payment_number',
				sortable: true,
				filter: 'agTextColumnFilter',
				minWidth: 150,
				autoHeight: true,
			},
			{
				headerName: 'Deferred to Date',
				field: 'deferred_to_date',
				sortable: true,
				filter: 'agTextColumnFilter',
				minWidth: 200,
				autoHeight: true,
			},
			{
				headerName: 'User',
				field: 'user',
				sortable: true,
				filter: 'agTextColumnFilter',
				minWidth: 200,
				autoHeight: true,
			},
			{
				headerName: 'Date Entered',
				field: 'date_entered',
				sortable: true,
				filter: 'agTextColumnFilter',
				minWidth: 200,
				autoHeight: true,
			},
		];
		this.defaultColDef_Def = {
			resizable: true,
		};
		this.getRowStyle_Def = (params) => {
			return { 'font-size': '15px' };
		};
	}

	async populateMetaDetails(){	
		console.log('Here is the Payoff and total due info');
		try {
			this.payoff = this.payoff_info['PayoffAmount'];
		} catch (err) {
			console.log('Maximum licenses have been reached');
			this.payoff = 'NA';
		}
		console.log('Payoff Information');
		console.log(this.payoff_info);
		this.meta.loan_group = this.payoff_info?.['LoanGroup'];
		this.meta.perdiem = this.payoff_info?.['PerDiem']?.toFixed(2);

		this.unbilledInterest = this.payoff - (this.collection_info?.current_principal_balance + this.collection_info?.total_current_due);
		this.unbilledInterest = this.unbilledInterest < 0 ? this.meta.perdiem : this.unbilledInterest.toFixed(2);

		if (this.loanMetaData?.['meta'].length != 0) {			
			this.dataFromMeta = this.loanMetaData?.['meta'][0];
		} else {
			this.dataFromMeta = this.collection_info;
		}
		try {
			this.meta.insurance_premium = this.dataFromMeta?.['Insurance Prem'];
		} catch (error) {
			this.meta.insurance_premium = 0;
		}
		try {
			this.meta.insurance_tax = this.dataFromMeta?.['Insurance Tax'];
		} catch (error) {
			this.meta.insurance_tax = 0;
		}
		try {
			this.meta.insurance = isNaN((
				this.meta.insurance_premium + this.meta.insurance_tax
			)?.toFixed(2)) ? 0 : (
				this.meta.insurance_premium + this.meta.insurance_tax
			)?.toFixed(2);
		} catch (error) {
			this.meta.insurance = 0;
		}
		try {
			this.meta.total_due = this.dataFromMeta?.total_past_due_balance;
			this.meta.total_due = this.meta.total_due.toLocaleString('en-US');
		} catch (err) {
			this.meta.total_due = 'NA';
		}
		this.meta.status_code = this.dataFromMeta?.status_code;
		this.meta.loan_status = this.dataFromMeta?.LoanStatus;
		this.meta.amortized_payment_amount =
			this.dataFromMeta?.amortized_payment_amount;
		this.meta.closed_date = this.dataFromMeta?.closed_date;
		this.meta.current_rate = this.dataFromMeta?.current_rate;
		this.meta.loan_group_no = this.dataFromMeta?.loan_group_no;
		this.meta.eff_fees_balance = (this.dataFromMeta?.eff_fees_balance === undefined) ? 0 : this.dataFromMeta?.eff_fees_balance;

		this.totalBalance = (parseFloat(this.meta.insurance) + this.collection_info.current_principal_balance + this.collection_info.current_interest_balance + this.meta.eff_fees_balance)?.toFixed(2);
		console.log('___________________________________________________________________');
		console.log('META INFORMATION');
		console.log(this.meta);
		this.meta.maturity_date = this.dataFromMeta?.maturity_date;
		this.isMatured = new Date(this.dataFromMeta?.maturity_date) < new Date() ? true : false;
		this.meta.open_date = this.dataFromMeta?.open_date;
		this.meta.origination_date = this.dataFromMeta?.origination_date;
		switch (this.dataFromMeta?.principal_period) {
			case 'DA': {
				this.meta.principal_period = 'Daily';
				break;
			}
			case 'WE': {
				this.meta.principal_period = 'Weekly';
				break;
			}
			case 'BW': {
				this.meta.principal_period = 'Bi-Weekly';
				break;
			}
			case 'SM': {
				this.meta.principal_period = 'Semi-Monthly';
				break;
			}
			case 'MO': {
				this.meta.principal_period = 'Monthly';
				break;
			}
			case 'S4': {
				this.meta.principal_period = 'Semi-Monthly';
				break;
			}
			default: {
				this.meta.principal_period = '';
			}
		}
	}

	nextLoan() {
		this.openAmoFlag = false;
		this.loanMetaService.next(); // Service handles the click-spam protection
	}

	previousLoan() {
		this.openAmoFlag = false;
		this.loanMetaService.previous();
	}

	// Notes
	displayEmails(e: string) {
		if (e === 'Email Notes') {
			this.selectedType_d = 'Internal Email';			
			this.apiService.getOfficeEmails().subscribe((res) => {
				this.officeEmails = res?.['data'];
			})
		}
	}

	// Create Note
	async createComment() {
		if (this.comment == '' || this.comment == undefined) {
			alert('Comment should not be empty');
		} else {
			console.log('THIS IS THE USER THAT IS GOING TO CREATE THE COMMENT');
			if (this.selectedType === 'Email Notes' && this.selectedType_d === 'Internal Email' && this.selectedEmail === '') {
				alert('Select an email address');
			} else {
				let result = await this.emailNotes();
				const bodyData = {					
					acctrefno: this.collection_info?.acctrefno,
					dealName: this.collection_info?.Name,
					comment: this.comment,
					type: this.selectedType,
					disposition: this.selectedType_d,
					created_by: this.userName,
					created_by_zoho_id: this.zohoUserID,
					zoho_app_record_id: this.collection_info?.cifnumber,
					email_sent: this.isEmail,
					email_sent_to: this.sentEmailAddress
				}
				this.loanMetaService.triggerAction(true,'SAVE',bodyData)
			}
		}
	}

	resetNoteForm(){
		this.comment = '';
		this.selectedType = 'Regular';
		this.selectedType_d = 'NO ANSWER';
		this.selectedEmail = '';
		this.sentEmailAddress = '';
		this.emailFormControl.reset();
		this.isEmail = false;	
	}

	async emailNotes() {
		return new Promise((resolve, reject) => {
			let sendLoanNumber = '';
			if (this.selectedType === 'Email Notes' && this.selectedType_d === 'Internal Email' && this.selectedEmail !== '') {
				this.sentEmailAddress = this.selectedEmail;
				sendLoanNumber = this.collection_info?.Loan_Number;
				this.apiService.toggleEmailNotes(this.comment, sendLoanNumber, this.collection_info?.Name, this.userID, this.sentEmailAddress, this.serverURL, 'meta', this.userName).subscribe((res) => {
					console.log(res, "Email Notes Internal")
					this.isEmail = true;
					resolve(true);
				})
			} else {
				this.sentEmailAddress = '';
				this.isEmail = false;
				resolve(false);
			}
		})
	}

	toggleSideNav() {
		this.isSideNavMenuOpen = !this.isSideNavMenuOpen;
	}

	openCommentForm(event: any) {
		console.log('This is the message we are sending to the comment form');
		const dataCopy = { ...event };
		Object.assign(dataCopy, { user_name: this.userName }); // Add signed in user for the Modal to detect the user
		this.apiService.sendMessage(event);
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '50%';
		dialogConfig.data = dataCopy; 
		const dialogRef = this.dialog.open(CommentFormComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(updatedNote => {
			if(updatedNote){
				this.loanMetaService.triggerAction(true,'RELOAD_ONLY',updatedNote);
			}else{
				return;
			}
		});
	}

	// Deferred Payments
	onGridReady_Def(params) {
		this.gridApi_Def = params.api;
		this.rowData_Def = this.Def_payment;
	}

	selectedTabValue(e) {
		if (e.tab.textLabel === "Future Payments") {
			this.openAmoFlag = true;
		}
		return false;
	}
	notesDataSource(): any[] {
		// Handle pagination
		const startIndex = (this.p - 1) * this.count;
		const endIndex = startIndex + this.count;

		return this.Comments_table ? this.Comments_table.slice(startIndex, endIndex) : [];
	}

	onPageChange(event: PageEvent): void {
		this.p = event.pageIndex + 1;
		this.count = event.pageSize;
	}

	/**
	 * If allowed, legal status can be updated or removed
	 * Explicit to Legal status code 35
	 * @returns 
	 */
	statusUpdate(){	
		let alertMsg='';	
		let requestType = '';
		if(this.legalStatusUpdateAccess?.includes(this?.empID)){			
			if(this.collection_info?.status_code_no === 35){
				alertMsg = "Remove LEGAL status?";
				requestType = 'remove';
				this.legalLoanStatusalertMsg(alertMsg,'remove');
			} else if(!this.collection_info?.status_code_no){
				alertMsg = "Update status to LEGAL?";
				this.legalLoanStatusalertMsg(alertMsg,'add');
			}else{
				console.log("Status update not allowed.")
				return;
			}
		}else{
			return;
		}
	}

	/**
	 * 
	 * @param alertMsg string alert message
	 * @param requestType Add/Remove
	 */
	legalLoanStatusalertMsg(alertMsg: string, requestType:string){
		this.saveAlertService.showSaveAlert(alertMsg, 
				() => this.loanMetaService.updateLegalStatus(this.collection_info?.acctrefno, this.collection_info?.status_code_no, requestType).pipe(
				tap(res =>{
					if(res?.status){
						this.meta.status_code = res?.newValue;	
						this.collection_info.status_code_no = res?.status_code_no;	
					}
				})
			)
			);
	}
	openTransunion(){	
		const mockActivatedRoute = {
		url: of([new UrlSegment('applications', {})]), // Mock url for Transunion
		pathFromRoot: [
			{}, // index 0 (root)
			{
				url: of([
					new UrlSegment('seg0', {}),
					new UrlSegment('seg1', {}),
					new UrlSegment(this.transunionAppID, {}) // index 2 (val[2]) for application ID for Transunion
				])
			}
		]
		};
		const dialogInjector = Injector.create({
			providers: [{ provide: ActivatedRoute, useValue: mockActivatedRoute }],
			parent: this.injector // Ensure other services remain available
			});
			
		this.dialog.open(SharedLoanMetaModalComponent, {
			injector: dialogInjector,
			height: '80vh',      // viewport
			width: '90vw',
			data: {isCollectorView:true, type: 'tranunion', appData:{application_id: this.transunionAppID, application_type: 'primary'}}	// Initial load 
		});
	}

	openWorkDrive(){	
		this.applicationService.getApplication(this.transunionAppID).subscribe({
			next: (res) => {
				this.dialog.open(SharedLoanMetaModalComponent, {
				height: '80vh',      // viewport
				width: '90vw',
				data: {isCollectorView:true, type: 'workdrive', external: this.externalRole, appData:{application_id: this.transunionAppID, application_type: 'primary', application: res}}	// Initial load 
		});
			},
			error: (error) => {
				console.error(error);
			},
		});	
	}

	openInNewTab() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['/details'])
		);
		window.open(url, '_blank');
}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

}
